import axios from 'axios'

export const notifyGtc = async (): Promise<void> => {
  const res = await axios.post('/notify/gtc')
}

export const notifyGdpr = async (): Promise<void> => {
  const res = await axios.post('/notify/gdpr')
}
